import { render } from "./Header.vue?vue&type=template&id=799e1233&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=799e1233&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799e1233"]])

export default __exports__